import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getUsers } from '../components/Application/Services/userService';

const useUsersStore = create(
  persist(
    (set, get) => ({
      users: [],
      isLoading: false,
      error: null,

      // Fetch users and update the store
      fetchUsers: async () => {
        set({ isLoading: true, error: null });
        try {
          const response = await getUsers();
          set({ users: response.data, isLoading: false });
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },

      // Optionally, a method to set users directly
      setUsers: (users) => set({ users }),
    }),
    {
      name: 'users-storage', // Key for localStorage persistence
    }
  )
);

export default useUsersStore;
